export default "__VITE_ASSET__BFt5vb5Y__"